<script setup lang="ts">
const props = defineProps<{
  label?: string | string[];
  type: "primary" | "secondary" | "warning" | "danger" | "success";
  textWhite?: boolean;
}>();

const hiddenLabels = computed(() => {
  const hiddenLabels = props.label?.slice(1);
  return (hiddenLabels as string[]).join(", ");
});
</script>

<template>
  <lxc-badge
    v-if="label && typeof label === 'string'"
    :type="type"
    :title="label"
  >
    {{ label }}
  </lxc-badge>
  <div v-else-if="label && label.length > 0" class="flex gap-1 items-center">
    <lxc-badge :type="type" :title="label[0]">{{ label[0] }}</lxc-badge>
    <lxc-badge v-if="label.length > 1" :type="type" :title="hiddenLabels">
      +{{ label.length - 1 }}
    </lxc-badge>
  </div>
</template>
